module.exports = __webpack_public_path__ + "static/media/modRank-5.4d20652c.svg";